/**
 * XAF -> EUR conversion for card payments (NytroPay/Stancer charges in EUR).
 *
 * MUST mirror the backend formula (apps/api .../Support/CurrencyConverter.php):
 * fixed BEAC peg, rounded UP to the cent, so the estimate shown at checkout is
 * exactly the amount charged.
 */
export const XAF_PER_EUR = 655.957;

/** EUR minor units (cents), rounded up — parity with backend xafToEurMinor(). */
export function xafToEurMinor(xafAmount: number): number {
  return Math.ceil((xafAmount * 100) / XAF_PER_EUR);
}

/** Decimal EUR amount (2 decimals, rounded up). */
export function xafToEur(xafAmount: number): number {
  return xafToEurMinor(xafAmount) / 100;
}

const eurFormatter = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
});

/** "22,87 €" for a given XAF amount. */
export function formatXafAsEur(xafAmount: number): string {
  return eurFormatter.format(xafToEur(xafAmount));
}
